import {
    getExamType,
    getPurchaseExamType,
    getNtseExamType,
    getExamTypeLibrary,
    getArchiveExamType,
    getArchiveExamTypeLibrary
} from '../../services/ExamTypeService';

import {
    logout,
} from '../actions/AuthActions';

import {
    GET_EXAM_TYPE_LIST,
    GET_PURCHASE_EXAM_TYPE_LIST,
    GET_NTSE_EXAM_TYPE,
    GET_EXAM_TYPE_LIBRARY
} from '../constants';

import * as utility from '../../utility/Utility';

export function getExamTypeData(category, history) {
    return (dispatch) => {
        getExamType(category)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getExamTypeAction(response.data.data));
                }
                if (response.data.status == 400) {
                    dispatch(logout(history));
                    utility.showError(response.data.msg);
                    return;
                }
            })
            .catch((error) => {
                //console.log(error);
                // utility.showError(error.response.data);
            });
    };
}
export function getPurchaseExamTypeData(history) {
    return (dispatch) => {
        getPurchaseExamType()
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getPurchaseExamTypeAction(response.data.data));
                }

                if (response.data.status == 400) {
                    dispatch(logout(history));
                    utility.showError(response.data.msg);
                    return;
                }
            })
            .catch((error) => {
                //console.log(error);
                // utility.showError(error.response.data);
            });
    };
}

export function getNtseExamTypeData(exam_category, exam_type_id, history) {
    return (dispatch) => {
        getNtseExamType(exam_category, exam_type_id)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getNtseExamTypeAction(response.data.data));
                }
                if (response.data.status == 400) {
                    dispatch(logout(history));
                    utility.showError(response.data.msg);
                    return;
                }
            })
            .catch((error) => {
                //console.log(error);
                // utility.showError(error.response.data);
            });
    };
}

export function getExamTypeLibraryData(category, history) {
    return (dispatch) => {
        getExamTypeLibrary(category)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getExamTypeLibraryAction(response.data.data));
                }
                if (response.data.status == 400) {
                    dispatch(logout(history));
                    utility.showError(response.data.msg);
                    return;
                }
            })
            .catch((error) => {
                //console.log(error);
                // utility.showError(error.response.data);
            });
    };
}

export function getArchiveExamTypeData(category,class_no, history) {
    return (dispatch) => {
        getArchiveExamType(category,class_no)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getExamTypeAction(response.data.data));
                }
                if (response.data.status == 400) {
                    dispatch(logout(history));
                    utility.showError(response.data.msg);
                    return;
                }
            })
            .catch((error) => {
                //console.log(error);
                utility.showError(error.response.data);
            });
    };
}

export function getArchiveExamTypeLibraryData(category,class_no, history) {
    return (dispatch) => {
        getArchiveExamTypeLibrary(category,class_no)
            .then((response) => {
                if (response.data.status == 200) {
                    dispatch(getExamTypeLibraryAction(response.data.data));
                }
                if (response.data.status == 400) {
                    dispatch(logout(history));
                    utility.showError(response.data.msg);
                    return;
                }
            })
            .catch((error) => {
                //console.log(error);
                utility.showError(error.response.data);
            });
    };
}

export function getExamTypeAction(data) {
    return {
        type: GET_EXAM_TYPE_LIST,
        payload: data,
    };
}
export function getPurchaseExamTypeAction(data) {
    return {
        type: GET_PURCHASE_EXAM_TYPE_LIST,
        payload: data,
    };
}

export function getNtseExamTypeAction(data) {
    return {
        type: GET_NTSE_EXAM_TYPE,
        payload: data,
    };
}

export function getExamTypeLibraryAction(data) {
    return {
        type: GET_EXAM_TYPE_LIBRARY,
        payload: data,
    };
}